import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
const FaqSeo = () => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (openIndexes.length === seoFaqData.length) {
      setOpenIndexes([]);
    } else {
      setOpenIndexes(seoFaqData.map((_, i) => i));
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  // faq data
  const seoFaqData = [
    {
      question: "What are SEO services and how do they help my business?",
      answer:
        "SEO (Search Engine Optimization) services improve your website’s visibility on search engines like Google, helping you attract more organic traffic, leads, and sales.",
    },
    {
      question: "Why should I choose Deetyasoft for SEO services in India?",
      answer:
        "Deetyasoft offers customized, data-driven SEO strategies including on-page, off-page, and local SEO to help you rank higher, drive traffic, and grow online.",
    },
    {
      question: "How long does it take to see results from SEO?",
      answer:
        "SEO is a long-term strategy. While minor improvements may appear in 1–2 months, significant traffic and ranking results typically take 3–6 months or more.",
    },
    {
      question: "Do you offer local SEO for small businesses?",
      answer:
        "Yes, we specialize in local SEO strategies that help small businesses appear in local search results, Google Maps, and near-me searches to attract nearby customers.",
    },
    {
      question: "Are your SEO services affordable for startups and SMEs?",
      answer:
        "Absolutely! Deetyasoft offers flexible and affordable SEO plans tailored for startups, small businesses, and enterprises with transparent pricing and ROI focus.",
    },
    {
      question: "What’s included in your SEO packages?",
      answer:
        " Our SEO packages include keyword research, website audit, technical SEO, content optimization, backlink building, and regular performance reporting.",
    },
  ];

  return (
    <div className="bg-white py-8">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
          <div className="w-full text-center md:pb-10">
            <h2 className="text-xl md:text-3xl font-semibold text-main">
              Frequently Asked Questions (Faq)
            </h2>
            <div className="border-b-4 border-main w-20 md:w-40 mx-auto my-2 rounded-full" />
          </div>

          <button
            onClick={toggleAll}
            className="text-sm font-medium text-black underline hover:text-blue-700 whitespace-nowrap sm:self-end"
          >
            {openIndexes.length === seoFaqData.length
              ? "Collapse all"
              : "Expand all"}
          </button>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {seoFaqData.map((item, index) => (
            <div
              key={index}
              className="rounded-xl shadow-sm overflow-hidden"
              data-aos="fade-up"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full bg-primaryPri flex justify-between items-center px-6 py-4 text-left"
              >
                <p className="md:text-lg text-sm font-medium text-black">
                  {item.question}
                </p>

                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`w-3 h-3 transform transition-transform ${
                    openIndexes.includes(index) ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openIndexes.includes(index) && (
                <div
                  className="px-6 pb-4 text-gray-700 text-xs md:text-sm"
                  data-aos="fade-down"
                >
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSeo;
